import constants from '../../../../../../../../../ahm-constants';

const PARTNER_AUTHORISATION_OPTIONS = [
  {
    text: 'Please select',
    value: '',
  },
  {
    text: 'Yes, my partner can manage, but not cancel the policy',
    value: constants.SPOUSAL_AUTHORITY.MANAGE,
  },
  {
    text: 'Yes, my partner can manage and cancel the policy',
    value: constants.SPOUSAL_AUTHORITY.MANAGE_AND_TERMINATE,
  },
  {
    text: 'No, my partner cannot manage or cancel the policy',
    value: constants.SPOUSAL_AUTHORITY.NO_AUTHORITY,
  },
] as const;

const SPOUSAL_AUTHORITY_DROPDOWN_HELPER = {
  [constants.SPOUSAL_AUTHORITY.MANAGE]:
    'They can do things like submit claims and change the cover. They cannot cancel or remove you from the policy.',
  [constants.SPOUSAL_AUTHORITY.MANAGE_AND_TERMINATE]:
    'They can do things like submit claims, change the cover and cancel the policy. They cannot remove you from the policy.',
  [constants.SPOUSAL_AUTHORITY.NO_AUTHORITY]: 'They will be unable to make changes to the policy.',
};

export { PARTNER_AUTHORISATION_OPTIONS, SPOUSAL_AUTHORITY_DROPDOWN_HELPER };
